<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'CustomMultiselect',
  components: { Multiselect },
  props: {
    name: {
      type: String,
      required: true,
    },
    rules: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      required: false,
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Seleccionar',
    },
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    customLabel: {
      type: Function,
      required: true,
    },
    taggable: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: Function,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    _value: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:value', value)
        this.$emit('input', value)
      },
    },
  },
}
</script>

<template>
  <div>
    <ValidationProvider
      v-slot="{ errors, classes }"
      :name="name"
      :rules="rules"
    >
      <b-form-group :label="label" :class="classes">
        <Multiselect
          :id="name"
          v-model="_value"
          :multiple="false"
          :placeholder="placeholder"
          track-by="url"
          :options="options"
          :internal-search="true"
          select-label="Seleccionar"
          selected-label="Seleccionado"
          deselect-label="Remover"
          :disabled="disabled"
          :custom-label="customLabel"
          :taggable="taggable"
          tag-placeholder="Enter para agregar"
          :loading="loading"
          @tag="tag"
        >
          <span slot="noOptions">Sin Información</span>
        </Multiselect>
        <b-form-invalid-feedback :state="errors.length === 0">
          {{ errors.join('. ') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </ValidationProvider>
  </div>
</template>

<style>
.invalid .multiselect__tags {
  border-color: #f04124 !important;
}
.validated.passed .multiselect__tags {
  border-color: #139e64 !important;
}
.multiselect,
.multiselect__input,
.multiselect__single,
.multiselect__tags {
  font-size: 0.875rem;
}
.multiselect__input {
  padding: 5px 0 0 5px;
}
.multiselect__tags {
  border: 1px solid #ced4da;
  padding: 5px 40px 0 7px;
  border-radius: 3px;
}
.multiselect__tag {
  margin-bottom: 2px;
  margin-top: 2px;
  padding: 5px 26px 5px 10px;
}
.multiselect__placeholder,
.multiselect__single {
  margin-bottom: 0px;
  padding-top: 4px;
}
</style>